<template>
  <div class="row"><h3></h3></div>
</template>

<script>
import router from "@/router";
import {useStore} from "vuex"
export default {

  mounted() {
    const store = useStore();    
        router.push("/dashboard");
  },
};
</script>
~
